import { Mui } from '@osu/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const BreadcrumbTrail = (props = {}) => {
  const { pathname, search } = useLocation() || {};
  const { routes, pageTitle, ...rest } = props;
  if (!Array.isArray(routes) || routes.length === 0 || !pathname) return null;
  let to = pathname;
  if (search) to += search;

  return (
    <Mui.Breadcrumbs {...rest} className="margin-bottom-3" aria-label="Breadcrumb">
      {routes.map((route, index) => (
       (<Mui.Link
          key={`breadcrumb#${index}`}
          variant="body2"
          color="inherit"
         underline="none"
          component={RouterLink}
          to={route.to}
        >
         {route.label}
       </Mui.Link>)
    //  route.label
      ))}
      <Mui.Link
        variant="body2"
        color="textPrimary"
        underline="none"
        aria-current="page"
        component={RouterLink}
        to={to}
      >
        {pageTitle}
      </Mui.Link>
    </Mui.Breadcrumbs>
  );
};

BreadcrumbTrail.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({ pathname: PropTypes.string }),
      ]),
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    })
  ),
  pageTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default BreadcrumbTrail;
